<div class="rfq-kit-items__wrapper">
  <form [formGroup]="form">
    <div class="row">
      <div class="col-md-12">
        <div formArrayName="kitItems">
          <table class="lum-table lum-table--classic striped">
            <thead>
              <tr>
                <th class="w-p35">SKU</th>
                <th class="w-40">Original Price</th>
                <th class="w-35">Quantity</th>
                <th class="w-p25">Unit <span class="text-red-700">*</span></th>
                <th class="w-40">Price</th>
                <th class="w-35">Total</th>
                <th>&nbsp;</th>
              </tr>
            </thead>
            <tbody>
              <ng-container
                *ngFor="let item of kitItemsControl?.controls; let idx = index"
              >
                <tr [formGroupName]="idx">
                  <td>
                    <lum-rfq-list-dropdown
                      placeholder="Search SKU or Product Name"
                      [rfqType]="'PRODUCT'"
                      (selectOptionEvent)="onSelectRfq($event, item)"
                    ></lum-rfq-list-dropdown>
                  </td>
                  <td>
                    <input
                      type="text"
                      class="lum-input"
                      formControlName="originalPrice"
                      readonly
                    />
                  </td>
                  <td>
                    <input
                      type="number"
                      inputmode="numeric"
                      min="1"
                      class="lum-input"
                      formControlName="quantity"
                      (input)="onUpdateLineTotal($event, idx)"
                    />
                  </td>
                  <td>
                    <mat-select class="lum-select" formControlName="uomId">
                      <mat-option
                        *ngFor="
                          let unit of item.value?.sku?.value?.unit_of_measures || []
                        "
                        [value]="unit.id"
                      >
                        {{ unit.name }}
                      </mat-option>
                    </mat-select>
                  </td>
                  <td>
                    <input
                      type="number"
                      inputmode="numeric"
                      min="0"
                      class="lum-input"
                      formControlName="price"
                      (input)="onUpdateLineTotal($event, idx)"
                    />
                  </td>
                  <td>
                    <input
                      type="text"
                      class="lum-input"
                      formControlName="lineTotal"
                      readonly
                    />
                  </td>
                  <td class="actions">
                    <button
                      class="lum-button lum-button--small lum-button--secondary w-20"
                      mat-icon-button
                      (click)="onRemoveItem(idx)"
                    >
                      <lum-ui-icon
                        icon="minus-circle"
                        [width]="16"
                        [height]="16"
                        color="#3a47af"
                      ></lum-ui-icon>
                    </button>
                  </td>
                </tr>
              </ng-container>
            </tbody>
            <tfoot>
              <tr>
                <td colspan="6" class="text-right">Total Selling Price</td>
                <td class="text-right">{{ totalSellingPrice | currency }}</td>
              </tr>
              <tr>
                <td colspan="6" class="text-right">Total Original Price</td>
                <td class="text-right">{{ totalOriginalPrice | currency }}</td>
              </tr>
            </tfoot>
          </table>
        </div>
        <div class="mt-4">
          <button
            type="button"
            class="lum-button btn-block"
            [matMenuTriggerFor]="menu"
          >
            Add Item(s)
          </button>
          <mat-menu
            class="lum-mat-menu"
            #menu="matMenu"
            yPosition="above"
            xPosition="before"
          >
            <button mat-menu-item (click)="onAddMultipleItems(1)">
              Add 1 Item
            </button>
            <button mat-menu-item (click)="onAddMultipleItems(5)">
              Add 5 Items
            </button>
            <button mat-menu-item (click)="onAddMultipleItems(10)">
              Add 10 Items
            </button>
            <button mat-menu-item (click)="onAddMultipleItems(25)">
              Add 25 Items
            </button>
            <button mat-menu-item (click)="onAddMultipleItems(50)">
              Add 50 Items
            </button>
          </mat-menu>
        </div>
      </div>
    </div>
  </form>
</div>
